<script>
import NoticeRecaptcha from '../components/NoticeRecaptcha'

export default {
  components: { NoticeRecaptcha },
  methods: {
    async injectRecaptcha(entry, actionName) {
      const recaptcha = await (async () => {
        try {
          return await this.$recaptchaToken(actionName)
        } catch (error) {
          throw new Error(this.$t('error'))
        }
      })()

      return {
        ...entry,
        recaptcha,
      }
    },
  },
}
</script>

<i18n>
{
  "en": {
    "error": "Google system could not validate that you are not an automated request. Please refresh the page and try again. If problem persists, please try again with a different browser or a different device."
  }
}
</i18n>
